import { useSEO } from "@/lib/seo";
import PageHeader from "@/components/sections/PageHeader";
import Brachytherapy from "@/components/sections/Brachytherapy";
import FinalCTA from "@/components/sections/FinalCTA";

export default function BrachytherapyPage() {
  useSEO({
    title: "Brachytherapy Specialist in Hyderabad",
    description:
      "Image-guided intracavitary, interstitial, intraluminal and surface mould brachytherapy. Focused radiation therapy planning by Dr. Anusha Mandava in Hyderabad.",
    keywords:
      "Brachytherapy Specialist Hyderabad, Intracavitary Brachytherapy, Interstitial Brachytherapy Hyderabad",
    path: "/brachytherapy",
  });

  return (
    <div data-testid="brachytherapy-page">
      <PageHeader
        eyebrow="Brachytherapy"
        title="Precision brachytherapy for selected cancers."
        description="Brachytherapy delivers radiation close to or within the tumour area. Dr. Anusha is adept at multiple brachytherapy forms and plans treatment based on cancer type, location and stage."
      />
      <Brachytherapy />
      <FinalCTA />
    </div>
  );
}
